import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { AUDIENCES } from "../data/content";

export const AudienceEntry = () => (
  <section className="bg-white py-24 md:py-32" data-testid="audience-section">
    <div className="container-x">
      <SectionHead
        kicker="Zielgruppen"
        testId="audience-title"
        title={<>Für wen wir <span className="font-fraktur text-golddark">arbeiten.</span></>}
        text="Privatkunden, Unternehmen und Kommunen stellen unterschiedliche Anforderungen. Wir liefern für alle drei – jeweils mit dem passenden Prozess."
      />
      <div className="grid md:grid-cols-3 gap-5">
        {AUDIENCES.map((a, i) => (
          <Reveal key={a.id} delay={i * 0.08} className="h-full">
            <Link
              to={a.to}
              data-testid={`audience-card-${a.id}`}
              className="group relative block h-[420px] md:h-[460px] overflow-hidden rounded-xl border border-line"
            >
              <img
                src={a.image}
                alt={`${a.overline} – Manfred Berglar, Malermeister seit 1925 Olpe`}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/55 to-ink/10 transition-opacity duration-500" />
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-herald scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" aria-hidden="true" />
              <div className="absolute inset-x-0 bottom-0 p-7">
                <p className="kicker-dark">{a.overline}</p>
                <h3 className="font-display text-2xl md:text-[1.7rem] font-semibold tracking-tight text-white mt-3 leading-tight">
                  {a.title}
                </h3>
                <p className="text-white/70 text-sm leading-relaxed mt-3 max-h-0 opacity-0 overflow-hidden group-hover:max-h-32 group-hover:opacity-100 transition-[max-height,opacity] duration-500">
                  {a.text}
                </p>
                <span className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.18em] font-bold text-herald mt-4">
                  Mehr erfahren <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
